<template>
  <div class="flex items-center mb-6">
    <FontAwesomeIcon :icon="faClipboardCheck" class="text-7xl text-brand mr-4" />

    <div class="text-sm">
      <h4 class="text-base font-medium">Red Tractor Assured</h4>

      <template v-if="listingIs.detailsVisible">
        <p>
          {{ listing.assurances[0].raw[0].sites.site.name }}
        </p>

        <p>
          <span class="text-brand font-bold">VALID</span>
          <span class="text-gray-darker">
            until {{ $date(listing.assurances[0].raw[0].expirydate).format('Do MMMM YYYY') }}
          </span>
        </p>
      </template>

      <template v-else>
        <UtilButton
          @click.native.stop.prevent="
            $store.dispatch('modal/showModal', {
              modalName: 'ModalAuthLogin',
              modalData: { redirectToDashboard: false }
            })
          "
          color="primary"
          class="mt-2 font-medium"
        >
          <FontAwesomeIcon :icon="faLockAlt" />
          <span>Upgrade for full details</span>
        </UtilButton>
      </template>
    </div>
  </div>
</template>

<script>
import { faClipboardCheck, faLockAlt } from '@fortawesome/pro-regular-svg-icons'
import UtilButton from '@/components/utils/UtilButton'

export default {
  name: 'UtilListingRedTractorAssured',
  components: {
    UtilButton
  },
  props: {
    listing: {
      type: Object,
      required: true
    },
    listingIs: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      faClipboardCheck,
      faLockAlt
    }
  }
}
</script>

<style lang="scss" scoped></style>
